module.exports = "/assets/e56a53933a0053e4ede925f6a4a61f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/EP.png
// module id = 759
// module chunks = 0